import { eventManager, Event } from './eventManager';
import {
  ToastContent,
  ToastItemOptions,
  ToastItemProps,
} from '../components/ToastItem/ToastItem.types';
import { ContainerInstance } from '../hooks/useToastContainer';

type EnqueuedToast = {
  content: ToastContent;
  options: ToastItemProps;
};

let container: ContainerInstance | undefined;
let queue: EnqueuedToast[] = [];

eventManager
  .on(Event.DidMount, (containerInstance: ContainerInstance) => {
    if (container) {
      return;
    }

    container = containerInstance;

    queue.forEach(item => {
      eventManager.emit(Event.Show, item.content, item.options);
    });

    queue = [];
  })
  .on(Event.WillUnmount, () => {
    container = undefined;

    eventManager.off(Event.Show).off(Event.Clear);
  });

const generateToastId = () => Math.random().toString(36).substring(2, 9);

const dispatchToast = (content: ToastContent, options: ToastItemProps) => {
  container
    ? eventManager.emit(Event.Show, content, options)
    : queue.push({ content, options });
};

const mergeOptions = (options?: ToastItemOptions) =>
  ({
    ...options,
    toastId: generateToastId(),
  } as ToastItemProps);

const showToast = (content: ToastContent, options?: ToastItemOptions) => {
  return dispatchToast(content, mergeOptions(options));
};

export { showToast };
